export function getConfirmedGroup(state) {
  return state.confirmedGroup.list.get(0);
}

export function getPreferencesList(state) {
  const confirmedGroup = getConfirmedGroup(state)
  if (confirmedGroup) {
    return confirmedGroup.preferences
  }
  else {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/core/confirmed-group/selectors.js